import styled from 'styled-components';
import { Box, IconButton, Typography } from '@material-ui/core';

export const FlexBoxHeader = styled(Box)`
  display: flex;
  align-items: center;
  overflow: hidden;
`;
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const FooterContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  bottom: 0;
  position: absolute;
  width: 100%;
`;

export const CloseButton = styled(IconButton)`
  margin: 0 16px 0 0 !important;
  padding: 0 !important;
  color: #dadada;
  width: 28px;
  height: 28px;
`;

export const HeaderTitle = styled(Typography).attrs({
    variant: 'h5',
})`
  font-size: 1.3rem !important;
`;

export const HeaderDescription = styled(Typography)`
  width: 75%;
  font-style: italic;
`;
